import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const AdminIntelligenceDashboard = withLazyFallback(
  () => import('components/admin/pages/Intelligence/AdminIntelligenceDashboard')
);
const AdminIntelligenceAiTask = withLazyFallback(
  () => import('components/admin/pages/Intelligence/AiTask/AdminIntelligenceAiTask')
);
const AdminIntelligenceModelTable = withLazyFallback(
  () => import('components/admin/pages/Intelligence/Model/AdminIntelligenceModelTable')
);
const AdminIntelligencePrompts = withLazyFallback(
  () => import('components/admin/pages/Intelligence/Prompt/AdminIntelligencePrompts')
);

const ADMIN_INTELLIGENCE = [
  {
    path: 'intelligence',
    element: <AdminIntelligenceDashboard />,
    handle: { title: 'Intelligence' },
    children: [
      { path: 'ai_tasks', element: <AdminIntelligenceAiTask />, handle: { title: 'AI Tasks' } },
      {
        path: 'models',
        element: <AdminIntelligenceModelTable />,
        handle: { title: 'Models' }
      },
      { path: 'prompts', element: <AdminIntelligencePrompts />, handle: { title: 'Prompts' } }
    ]
  }
];

export default ADMIN_INTELLIGENCE;
